export default __webpack_public_path__ + "static/media/ChaiWai.992a78745c1490e1182bb49c1b4d0ef8.webp";